__webpack_require__.p = "/dynamic-pdfjs/onboarding/";